import {
	Component,
	AfterViewInit,
	OnInit,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef
} from '@angular/core';
import { v4 as uuid } from 'uuid';
import { IRouteObject } from './topnavitem.types';

@Component({
	selector: 'rbc-top-nav-item',
	templateUrl: './topnavitem.component.html',
	styleUrls: ['./topnavitem.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class TopnavitemComponent implements OnInit, AfterViewInit {
	isDropdownItem = false;
	@Input() dropdown: boolean = false;
	@Input() dropdownArrow: boolean = true;
	@Input() control: boolean = false;
	@Input() dropdownPosition: string = 'center';
	@Input() dropdownType: string = 'click';
	@Input() dropdownTag: string;
	@Input() icon: string;
	@Input() iconWeight: string = 'regular';
	@Input() router: boolean = false;
	@Input() target: string = '_blank';
	@Input() href: string;
	@Input() active: boolean = false;
	@Input() routerTo: string;
	@Input() profileImage: string;
	@Input() id: string = uuid();
	@Input() routeObject: IRouteObject;

	@Output() onClick = new EventEmitter();

	@ViewChild('dropdownItem') dropdownItem: ElementRef;

	constructor() {}

	ngOnInit() {}

	ngAfterViewInit() {
		setTimeout(() => this.checkDropdownItem(), 250);
	}

	itemClicked(e) {
		this.onClick.emit(e);
	}

	checkDropdownItem() {
		if (this.dropdownItem) {
			let el = this.dropdownItem.nativeElement;
			while (el.parentElement && this.isDropdownItem === false) {
				el = el.parentElement;
				if (el.classList.contains('menu')) {
					this.isDropdownItem = true;
				}
			}
			this.dropdownItem.nativeElement.remove();
		}
	}

	classGen() {
		const { control, dropdown, profileImage, dropdownArrow } = this;

		return {
			'nav-item-control': control,
			'nav-item-dropdown': dropdown,
			'nav-item-profile': profileImage,
			'nav-dropdown-arrow': dropdownArrow && dropdown
		};
	}
}
